export default "__VITE_ASSET__O0V5WS5$4bim9OQ6gLASIg__";